<template>
  <div v-loading="loading">
    <div class=' content'>
      <div class="s_wrapper">
        <el-input class="s_input" placeholder="请输入门店名称" suffix-icon="el-icon-search" v-model="storeName" clearable
          @change="onSearch"></el-input>
        <el-input class="s_input" placeholder="请输入用户编号" suffix-icon="el-icon-search" v-model="userCode" clearable
          @change="onSearch"></el-input>
        <el-input class="s_input" placeholder="请输入订单编号" suffix-icon="el-icon-search" v-model="orderCode" clearable
          @change="onSearch"></el-input>
        <el-input class="s_input" placeholder="请输入售后单号" suffix-icon="el-icon-search" v-model="refundCode" clearable
          @change="onSearch"></el-input>
        <el-select class="s_input" v-model="refundType" placeholder="请选择售后状态" clearable @change="onSearch">
          <el-option v-for="item in refundTypeArr" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <!-- 表格 -->
      <div class="g_table">
        <el-table max-height="540" :data="tableData">
          <el-table-column label="序号" min-width="60" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column prop="storeName" label="门店名称" show-overflow-tooltip min-width="150" align="center">
          </el-table-column>
          <el-table-column prop="userCode" label="用户编号" show-overflow-tooltip min-width="120" align="center">
          </el-table-column>
          <el-table-column prop="orderCode" label="订单编号" show-overflow-tooltip min-width="180" align="center">
          </el-table-column>
          <el-table-column prop="refundCode" label="售后单号" show-overflow-tooltip min-width="180" align="center">
          </el-table-column>
          <el-table-column prop="refundType" label="售后类型" show-overflow-tooltip min-width="100" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.refundType == 1">退货退款</div>
              <div v-if="scope.row.refundType == 2">仅退款</div>
            </template>
          </el-table-column>
          <el-table-column label="退款金额" min-width="180" align="center">
            <template slot-scope="scope">
              <div>{{ `￥${scope.row.refundAmount}` }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="orderTime" label="下单时间" min-width="180" align="center">
          </el-table-column>
          <el-table-column prop="returnTime" label="申请时间" min-width="180" align="center">
          </el-table-column>
          <el-table-column prop="status" label="售后状态" show-overflow-tooltip min-width="100" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0" style="color: red;">待处理</div>
              <div v-if="scope.row.status == 1">已退款</div>
              <div v-if="scope.row.status == 2">退款失败</div>
              <div v-if="scope.row.status == 3">已撤销</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="150" header-align="center" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="small" plain @click="handleCommand(scope.row)">查看订单</el-button>
              <el-button type="primary" size="small" @click="handleOneHandle(scope.row)"
                v-if="scope.row.storeName == null && scope.row.status == 0">售后处理</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
        layout="prev, pager, next, jumper, sizes, total" :total="totalCount">
      </el-pagination>
    </div>
    <child :showFlag="showFlag" @closeChildDialog="closeChildDialog" :ruleForm="ruleForm">
    </child>
  </div>
</template>

<script>
import child from './detail/dialog.vue'
export default {
  components: {
    child,
  },
  data() {
    return {
      loading: false,
      ruleForm: {},//售后弹窗
      showFlag: false,//售后弹窗显隐
      // 表格数据
      tableData: [],
      // 分页器
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50],
      totalCount: 0, // 总记录数据
      refundTypeArr: [
        {
          value: '0',
          label: '待处理'
        }, {
          value: '1',
          label: '已退款'
        }, {
          value: '2',
          label: '退款失败'
        }, {
          value: '3',
          label: '已撤退'
        },
      ],
      refundType: '',//售后类型
      orderCode: '',//订单编号
      refundCode: '',//售后编号
      userCode: '',//用户编号
      storeName: '',//门店名称
    }
  },
  created() {
    this.getRequest()//请求数据
  },
  methods: {
    handleClick(tab) {
      const { name } = tab
      this.orderStatus = name
      this.getRequest()
    },
    // 请求
    getRequest() {
      this.loading = true;
      this.$axios.get(this.$api.productRefundOrderList, {
        params: {
          refundType: this.refundType || null,//售后状态：0待处理,1已退款,2退款失败,3已撤销
          refundCode: this.refundCode || null,//售后单号
          orderCode: this.orderCode || null,//订单编号
          userCode: this.userCode || null,//用户编号
          storeName: this.storeName || null,//门店名称
          page: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then((res) => {
        const { code, result } = res
        if (code == 100) {
          this.totalCount = result.totalCount
          this.tableData = result.list || []
          this.loading = false;
        }
      }).catch((err) => {
        this.$message.error(err.desc)
        this.loading = false;
      })

    },
    // 时间区间搜索
    gettime() {
      this.startTime = this.formInline.time ? this.formInline.time[0] || "" : "";
      this.endTime = this.formInline.time ? this.formInline.time[1] || "" : "";
      this.getRequest()
    },
    handleCommand(row) {
      this.$router.push({ name: 'afterSaleOrderDet', query: { orderRefundId: row.orderRefundId } })
    },
    handleOneHandle(row) {
      this.showFlag = true
      this.ruleForm = row
    },
    //  接受子组件调用的关闭弹出框方法
    closeChildDialog() {
      this.showFlag = false
      this.onSearch()
    },
    // 清空
    clearData() {
      this.tableData = [];
      this.currentPage = 1;
    },
    // 搜索
    onSearch() {
      this.clearData();
      this.getRequest();
    },
    handleSizeChange(e) {
      this.pageSize = e
      this.getRequest()
    },
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequest()
    },
  },
}
</script>

<style scoped lang='scss'>
.content {
  .el-date-editor {
    margin-left: 10px !important;
  }

  .header-btn {
    margin-left: 10px;
  }
}


.tableBox {
  overflow: auto;

  :deep .el-table--group::after,
  .el-table--border::after,
  .el-table::before {
    content: "";
    position: absolute;
    background-color: #ebeef5;
    opacity: 0;
  }

  :deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
    /*滚动条宽度*/
    height: 4px;
    /*滚动条高度*/
  }
}

// 操作下拉框内容
.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-date-editor,
.el-range-editor,
.el-input__inner,
.el-date-editor--daterange {
  margin-left: 0px !important;
}

.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 250px;
}
</style>
